import { Database20Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const DataOverviewPage = lazyPage(() => import('./tools/overview/pages/DataOverviewPage'));
const DataExplorerPage = lazyPage(() => import('./tools/explorer/pages/DataExplorerPage'));
const DataExplorerLabPage = lazyPage(() => import('./tools/lab/pages/DataExplorerLabPage'));

const dataModuleConfig = createModuleConfig({
  key: 'data',
  name: 'Data',
  domain: { title: 'Data', icon: Database20Regular },
  tools: [
    {
      key: 'overview',
      name: 'Overview',
      title: 'Data Overview',
      path: '/data/overview',
      aliases: ['/data'],
      element: <DataOverviewPage />,
      nav: { name: 'Overview', icon: Database20Regular },
    },
    {
      key: 'explorer',
      name: 'Explorer',
      title: 'Data Explorer',
      path: '/data/explorer',
      element: <DataExplorerPage />,
      nav: { name: 'Explorer', icon: Database20Regular },
    },
    {
      key: 'explorer-lab',
      name: 'Explorer Lab',
      title: 'Explorer Lab',
      path: '/data/explorer-lab',
      element: <DataExplorerLabPage />,
      nav: { name: 'Explorer Lab', icon: Database20Regular },
      shouldHide: true
    },
  ],
});

export default dataModuleConfig;